import * as React from 'react';
import { Layout } from 'react-admin';
import CustomAppBar from './AppBar';
import CustomMenu from './Menu';

const CustomLayout = (props: any) => <Layout {...props} appBar={CustomAppBar} menu={CustomMenu} />;

export default CustomLayout;
